<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/components/views/customer/quality_control/query_container/quality_inspect_info.yml"
  lang="yaml"
></i18n>
<template>
  <div class="my-8" v-if="quality_inspect">
    <div class="panel">
      <div class="panel-header columns-2">
        <h3 class="panel-header-title">{{ $t("labels.title") }}</h3>
      </div>

      <div class="panel-body" v-show="open">
        <div class="divide-y divide-slate-200">
          <div class="grid grid-cols-1 gap-y-8 gap-x-4 sm:grid-cols-2">
            <div class="sm:col-span-1">
              <dt class="label-data">
                {{ $t("model.quality_inspect.week") }}
              </dt>
              <dd class="content-data">
                {{ quality_inspect.week }}
              </dd>
            </div>

            <div class="sm:col-span-1">
              <dt class="label-data">
                {{ $t("model.quality_inspect.registered_at") }}
              </dt>
              <dd class="content-data">
                {{ dateFormatterDayMonthName(quality_inspect.registered_at) }}
              </dd>
            </div>
            <div class="sm:col-span-1">
              <dt class="label-data">
                {{ $t("model.quality_inspect.inspect_code") }}
              </dt>
              <dd class="content-data">
                {{ quality_inspect.inspect_code }}
              </dd>
            </div>
            <div class="sm:col-span-1" v-if="producerOrOrganizationLabel(quality_inspect.exported_batch)">
              <dt class="label-data">
                {{ $t("model.quality_inspect.provider") }}
              </dt>
              <dd class="content-data">
                {{
                  producerOrOrganizationLabel(quality_inspect.exported_batch)
                }}
              </dd>
            </div>
            <div
              class="sm:col-span-1"
              v-if="quality_inspect?.quality_template?.use_samplings"
            >
              <dt class="label-data">
                {{ $t("model.quality_inspect.samplings") }}
              </dt>
              <dd class="content-data">
                {{ quality_inspect.samplings }}
              </dd>
            </div>
            <div class="sm:col-span-1">
              <dt class="label-data">
                {{ $t("model.quality_inspect.quality_accepted_percent") }}
              </dt>
              <dd class="content-data">
                {{ quality_inspect.quality_accepted_percent }}%
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.quality_inspect.observations") }}
              </dt>
              <dd class="content-data">
                {{ quality_inspect.observations }}
              </dd>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QualityInspectInfoReadOnly",
  data: () => ({
    open: true
  }),
  props: {
    quality_inspect: {
      type: Object,
      required: true
    }
  },
  methods: {
    producerOrOrganizationLabel(exported_batch) {
      if (!exported_batch) return;
      let label = "";
      if (exported_batch.producer) label += exported_batch.producer.name;
      if (exported_batch.organization) {
        if (label) label += ` (${exported_batch.organization.name})`;
        else label += exported_batch.organization.name;
      }
      return label;
    }
  }
};
</script>
